<script>
    import { onMount } from "svelte";
    import MyPageination from "./mypageination.svelte";

    // 列表数据
    let page_num = 1;
    let per_page = 10;
    let total_count = 0;
    let total_page = Math.ceil(total_count / per_page);
    let list_url = "/dbapi/rolelist";
    let count_url = "/dbapi/rolecount";
    let add_url = "/dbapi/roleinfo";
    let del_url = "/dbapi/roledelete";
    let pmt_url = "/dbapi/permitinfo";
    let rdatas = [];

    // 对话框数据
    let dlg_title = "";
    let dlg_mode = 0; // 0 添加模式，1 修改模式
    let dlg_rolename = "";
    let dlg_roledesc = "";
    let dlg_permits = [];
    let dlg_users = [];
    let dlg_rolepermits = [];
    let dlg_rolemembers = [];

    // 加载事件函数
    onMount(() => {
        getRoleCount();
        readRoleList();
        loadPermitInfo();
    });
    // 切换页面
    function switchPage(topage) {
        page_num = topage;
        readRoleList();
    }
    // 取角色总数
    function getRoleCount() {
        jQuery.ajax({
            type: "get",
            url: count_url,
            success: function (response) {
                if (response.code == 200) {
                    total_count = response.result;
                    total_page = Math.ceil(total_count / per_page);
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 读取角色列表
    function readRoleList() {
        let tmp_url = list_url + "?page=" + page_num + "&count=" + per_page;
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        rdatas = response.result;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 读取权限数组和用户数组
    function loadPermitInfo() {
        jQuery.ajax({
            type: "get",
            url: pmt_url,
            success: function (response) {
                if (response.code == 200) {
                    let pmts = response.result.permits;
                    let usrs = response.result.users;
                    if (Array.isArray(pmts)) dlg_permits = pmts;
                    if (Array.isArray(usrs)) dlg_users = usrs;
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 重置对话框信息
    function resetDialogData() {
        dlg_mode = 0;
        dlg_rolename = "";
        dlg_roledesc = "";
    }
    // 弹出新增角色对话框
    function newRole() {
        dlg_title = "新增角色";
        resetDialogData();
        jQuery("#role-modal").modal("show");
        return;
    }
    // 加载角色信息
    function LoadRoleInfo(rolename) {
        let tmp_url = add_url + "?rolename=" + rolename;
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    let rdata = response.result;
                    dlg_rolename = rdata["rolename"];
                    dlg_roledesc = rdata["roledesc"];
                    dlg_rolepermits = rdata["permits"];
                    dlg_rolemembers = rdata["members"];
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 弹出编辑角色对话框
    function editRole(rolename) {
        dlg_title = "修改角色信息";
        dlg_mode = 1;
        // 加载数据
        LoadRoleInfo(rolename);
        jQuery("#role-modal").modal("show");
        return;
    }
    // 提交数据
    function submitData() {
        // 保存操作
        let rdata = {
            mode: dlg_mode,
            rolename: dlg_rolename,
            roledesc: dlg_roledesc,
        };
        jQuery.ajax({
            type: "post",
            url: add_url,
            data: JSON.stringify(rdata),
            success: function (response) {
                if (response.code == 200) {
                    if (dlg_mode == 1) {
                        // 修改模式，还需要保存权限和成员
                        let rpdata = {
                            rolename: dlg_rolename,
                            permits: dlg_rolepermits,
                            users: dlg_rolemembers,
                        };
                        jQuery.ajax({
                            type: "post",
                            url: "/dbapi/rolepermitchange",
                            data: JSON.stringify(rpdata),
                            success: function (response) {
                                if (response.code == 500) {
                                    console.log(
                                        "update permit and member error:" +
                                            response.result
                                    );
                                }
                            },
                            error: function (err) {
                                console.log(
                                    "update permit and member failed:" + err
                                );
                            },
                        });
                    }
                    // 关闭对话框
                    jQuery("#role-modal").modal("hide");
                    resetDialogData();
                    // 更新列表
                    getRoleCount();
                    readRoleList();
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 删除角色
    function deleteRole(rolename) {
        if (confirm("删除角色" + rolename + "，是否继续？")) {
            // 删除操作
            let dtarget = { target: rolename };
            jQuery.ajax({
                type: "post",
                url: del_url,
                data: JSON.stringify(dtarget),
                success: function (response) {
                    if (response.code == 200) {
                        // 更新列表
                        getRoleCount();
                        readRoleList();
                    }
                },
                error: function (err) {
                    console.log(err);
                },
            });
        }
    }
    function id2user(id) {
        let sRet = "";
        for (let i = 0; i < dlg_users.length; i++) {
            if (dlg_users[i].id == id) {
                sRet = dlg_users[i].cnname + "(" + dlg_users[i].nickname + ")";
                break;
            }
        }
        return sRet;
    }
</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>角色列表</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">所有角色</h3>
                            <div class="card-tools">
                                <button
                                    type="submit"
                                    class="btn btn-default"
                                    on:click={newRole}
                                >
                                    <i class="bi bi-journal-plus" /> 添加
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- data list-->
                            <div class="row">
                                <table class="table table-bordered table-hover">
                                    <thead class="thead-light">
                                        <tr>
                                            <th width="25%">角色编码</th>
                                            <th width="45%">角色名称</th>
                                            <th width="30%">操作</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each rdatas as rdata}
                                            <tr>
                                                <td>{rdata.rolename}</td>
                                                <td>{rdata.roledesc}</td>
                                                <td>
                                                    <span class="record_op_normal" title="修改">
                                                        <i
                                                            class="bi bi-journal-text"
                                                            on:click={() => editRole(rdata.rolename)}
                                                            on:keyup={() => {}} role="button" tabindex="0"
                                                        />
                                                    </span>
                                                    <span class="record_op_warn" title="删除">
                                                        <i
                                                            class="bi bi-journal-x"
                                                            on:click={() => deleteRole(rdata.rolename)}
                                                            on:keyup={() => {}} role="button" tabindex="0"
                                                        />
                                                    </span>
                                                </td>
                                            </tr>
                                        {/each}
                                    </tbody>
                                </table>
                            </div>
                            <!-- page -->
                            <MyPageination
                                current_page={page_num}
                                page_count={total_page}
                                switch_page_func={switchPage}
                            />
                        </div>
                    </div>
                    <!--/ end of card -->
                </div>
            </div>
        </div>
    </section>
</div>
<!-- role modal dialog -->
<div class="modal fade" id="role-modal" data-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{dlg_title}</h4>
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form class="form-lrpadding">
                    <input type="hidden" bind:value={dlg_mode} />
                    <div class="form-group row">
                        <label
                            for="inputRolename"
                            class="col-sm-2 col-form-label">角色代码</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="text"
                                class="form-control"
                                id="inputRolename"
                                readonly={dlg_mode == 1}
                                bind:value={dlg_rolename}
                                placeholder="不允许为空"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            for="inputRoledesc"
                            class="col-sm-2 col-form-label">角色描述</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="text"
                                class="form-control"
                                id="inputRoledesc"
                                bind:value={dlg_roledesc}
                                placeholder="不允许为空"
                            />
                        </div>
                    </div>
                    {#if dlg_mode === 1}
                        <div class="form-group row">
                            <label
                                for="inputRolePermits"
                                class="col-sm-2 col-form-label">角色权限</label
                            >
                            <div class="col-sm-10">
                                {#each dlg_permits as permit}
                                    <div
                                        class="col-sm-3"
                                        style="display:inline-block"
                                    >
                                        <input
                                            type="checkbox"
                                            bind:group={dlg_rolepermits}
                                            value={permit.permitcode}
                                        />
                                        {permit.permitname}
                                    </div>
                                {/each}
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="inputRoleMembers"
                                class="col-sm-2 col-form-label">角色成员</label
                            >
                            <div class="col-sm-10">
                                <div
                                    style="word-break:break-all;padding-bottom:0.5em"
                                >
                                    <b>
                                        {#each dlg_rolemembers as seluser}
                                            {id2user(seluser)},&nbsp;
                                        {/each}
                                    </b>
                                </div>
                                <div style="height:120px;overflow:auto">
                                    {#each dlg_users as user}
                                        <div
                                            class="col-sm-4"
                                            style="display:inline-block"
                                        >
                                            <input
                                                type="checkbox"
                                                bind:group={dlg_rolemembers}
                                                value={user.id}
                                            />
                                            {user.cnname}({user.nickname})
                                        </div>
                                    {/each}
                                </div>
                            </div>
                        </div>
                    {/if}
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal">关闭</button
                >
                <button
                    type="button"
                    class="btn btn-primary"
                    on:click={submitData}>保存</button
                >
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<style>
    .record_op_normal {
        font-size: 18px;
        padding-left: 8px;
        padding-right: 8px;
        color: darkblue;
        cursor: pointer;
    }
    .record_op_warn {
        font-size: 18px;
        padding-left: 8px;
        padding-right: 8px;
        color: red;
        cursor: pointer;
    }
    .form-lrpadding {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
